import { ReactElement, useEffect, useState } from 'react'
import FadeCarouselProps from './props'
import * as S from './styled'

export default function FadeCarousel ({ children }: FadeCarouselProps): ReactElement {
  const [activeIndex, setActiveIndex] = useState(0)

  useEffect(() => {
    const timer = setTimeout(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % children.length)
    }, 3000)

    return () => clearTimeout(timer)
  }, [activeIndex, children.length])

  const goToSlide = (index: number): void => {
    setActiveIndex(index)
  }

  return <S.CarouselContainer>
    {children.map((child, index) => <S.Slide key={index} $isActive={index === activeIndex}>
      {child}
    </S.Slide>)}

    <S.DotsContainer>
      {children.map((_, index) => <S.Dot
        key={index}
        $isActive={index === activeIndex}
        onClick={() => goToSlide(index)}
      />)}
    </S.DotsContainer>
  </S.CarouselContainer>
}
